import React from 'react';
var ASSET_PATH = '/static/assets/img/';
/*
  the acquirer/payfac that returns to us the type has different values than stripe
   - Discover
   - Amex
*/
function typeToImagepath(type) {
    switch (type === null || type === void 0 ? void 0 : type.toLowerCase()) {
        case 'discover':
            return 'discover_network';
        case 'amex':
            return 'american_express';
        case 'diners club':
            return 'diners_club_int';
        case 'jcb':
        case 'visa':
        case 'mastercard':
            return type.replace(' ', '_').toLowerCase();
        default:
            return 'generic_credit_card';
    }
}
export default function CardTypeDisplay(props) {
    return (React.createElement("img", { style: { width: '32px', height: 'fit-content' }, src: "" + ASSET_PATH + typeToImagepath(props.type) + ".png" }));
}
